import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  id: string;
  image: string;
  name: string;
  name_malay: string;
  name_mandarin: string;
  label: string;
  description: string;
  description_malay: string;
  description_mandarin: string;
  button_text: string;
  redirect_url: string;
  project_airport_id: any;
  type_banner_image: string;
  mobile_image: string;
  mobile_banner_image: string;
  type_description_en: string;
  type_description_ms: string;
  type_description_zh: string;
  field_category_map_field_malay:string;
  field_category_map_field:string;
  field_category_map_field_mandria:string;
  sequence: string;
  published: string;
}

// edit api call
const fetchPageContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/type-shop-dine/${id}`);

  return response?.data[0];
};

const usePageDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["pageContenDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchPageContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePageDocumentDetails };
